import { useAboutYouStore } from "./aboutYou";
import { useConfigStore } from "./config";
import { useDailyActivitiesStore } from "./dailyActivities";
import { useDependantAboutYouStore } from "./dependantAboutYou";
import { useDependantDailyActivitiesStore } from "./dependantDailyActivities";
import { usePensionOptionsStore } from "./pensionOptions";
import { useQuoteStore } from "./quotes";
import { useSessionTimeoutStore } from "./sessionTimeout";
import { useYourDetailsStore } from "./yourDetails";
import { useFinallyStore } from "./finally";

export function getStores() {
    const yourDetailsStore = useYourDetailsStore();
    const pensionOptionsStore = usePensionOptionsStore();
    const aboutYouStore = useAboutYouStore();
    const dependantAboutYouStore = useDependantAboutYouStore();
    const dailyActivitiesStore = useDailyActivitiesStore();
    const dependantDailyActivitiesStore = useDependantDailyActivitiesStore();
    const finallyStore = useFinallyStore();

    const quoteStore = useQuoteStore();

    const sessionTimeoutStore = useSessionTimeoutStore();
    const config = useConfigStore();

    return {
        yourDetailsStore,
        pensionOptionsStore,
        aboutYouStore,
        dependantAboutYouStore,
        dailyActivitiesStore,
        dependantDailyActivitiesStore,
        finallyStore,

        quoteStore,

        sessionTimeoutStore,
        config,
    };
}
